import React from "react";
import { Typography } from "antd";
import { useTranslation } from "react-i18next";
import DealNotificationModel from "../../../../viewModels/Notification/DealNotificationModel";

const DealQuestionDeliveryStatus = React.memo(({ notification }: { notification: DealNotificationModel }) => {
  const { t } = useTranslation("translations");
  const statuses = notification.deliveries?.map((delivery) => delivery.status) || [];
  if (statuses.includes("UNKNOWN")) return <Typography.Text type="warning">{t("delivery_outcome_unknown")}</Typography.Text>;
  if (statuses.includes("ERROR")) return <Typography.Text type="warning">{t("delivery_failed")}</Typography.Text>;
  if (statuses.some((status) => status === "PENDING" || status === "NOTIFYING")) {
    return <Typography.Text type="secondary">{t("delivery_pending")}</Typography.Text>;
  }
  return null;
});

export default DealQuestionDeliveryStatus;
